module.exports = __webpack_public_path__ + "static/media/nxt.8684fe31.svg";